import Swiper from 'swiper';

export default class Announcement {
    constructor(el) {

        this.height = el.clientHeight
        this.swiper = el.querySelectorAll('.swiper')
        this.header = document.querySelector('.c-page-header')
        
        this.init();

        if(this.swiper.length >=1) {
            this.bannerSwiper()
        }
    }

    init() {
        this.height = this.height + 'px';

        this.header.style.setProperty('--announcement-height', this.height)
    }

    bannerSwiper() {
        // console.log('this.swiper :>> ', this.swiper[0]);

        if(this.swiper[0].classList.contains('anouncementSwiper__slider')) {
            var anouncementSwiper = new Swiper(".anouncementSwiper", {
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                autoplay: {
                    delay: 5000,
                },
                loop: true,
            });
        } else {
            var anouncementSwiper = new Swiper(".anouncementSwiper", {
                spaceBetween: 0,
                centeredSlides: true,
                speed: 9000,
                autoplay: {
                    delay: 1,
                },
                loop: true,
                slidesPerView: "auto",
                allowTouchMove: false,
                disableOnInteraction: true
            });
        }
    }
}
